/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { inject } from "mobx-react";
import { ContextMenuItem } from "components/contextMenu/ContextMenuItem";
import { contextMenuManager } from "contextMenuManager";
import { pageContentHandler } from "pageContentHandler";
import { isTouchSelectionPresent, isThereAnySelection } from "dc-preview-utils/src/selectors/touchSelectors";
import { getBrowser } from "dc-preview-utils/src/Utils/UserAgentUtils";
import { getContextMenuItemStyle, getContextMenuTriggerEventObj } from "selectors/contextMenuSelectors";
import { getZoomedQuadsObj } from "utils/SelectionUtils";
import { getShouldUseModernViewer, getShouldUseMobileModernViewer } from "selectors/appSelectors";
import { getCoordinatesRelativeToPage } from "utils/EventHandlingUtils";
import { getContextMenuTriggerPageIndex } from "selectors/contextMenuSelectors";
import { getDocumentInfoApis } from "publicApis/DocumentInfo.js";
import { getDocumentStateApis } from "publicApis/DocumentState.js";
import { VERBS_QANDA } from "constants/enums.js";

function mapStoreToProps(stores, ownProps) {
  return {
    getExtraParams: verbId => {
      const params = {};
      if (isThereAnySelection(stores)) {
        const quadsObj = pageContentHandler.getTextManagerInstance().quads;
        if (quadsObj && quadsObj.quadsArray) {
          params.quads = getZoomedQuadsObj(quadsObj.quadsArray, stores);
          params.pdfQuads = getZoomedQuadsObj(quadsObj.quadsArray, stores, false);
        }
      }
      const eventObj = getContextMenuTriggerEventObj(stores);
      params.clickPoint = getCoordinatesRelativeToPage(eventObj);
      params.pageIndex = getContextMenuTriggerPageIndex(stores);
      params.contextMenuTriggerEventObj = eventObj;
      if (VERBS_QANDA.includes(verbId)) {
        params.getPageAttributes = getDocumentInfoApis(stores).getPageAttributes;
        params.getSelectedContent = getDocumentStateApis(stores).getSelectedContent;
      }
      return params;
    },
    ...ownProps,
    browserInfo: getBrowser(),
    contextMenuItemStyle: getContextMenuItemStyle(stores),
    clearTouchSelectionIfPresent: () => {
      if (isTouchSelectionPresent(stores) === true) {
        contextMenuManager.clearMenuItems(stores);
        pageContentHandler.getTextManagerInstance().clearSelection(stores);
      }
    },
    useModernViewer: getShouldUseModernViewer(stores)
  };
}

const ContextMenuItemContainer = inject(mapStoreToProps)(ContextMenuItem);

export { ContextMenuItemContainer };
